import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HomeHero from "./components/HomeHero";
import FeaturedComics from "./components/FeaturedComics";
import LatestUpdates from "./components/LatestUpdates";
import CategoryNav from "./components/CategoryNav";
import StatsSection from "./components/StatsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "韩漫大全漫画网",
        url: "http://uhomekj.com/",
        description: "韩漫大全漫画网提供下拉式免费韩漫在线阅读，海量无删减韩漫资源。",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "400-888-9999",
          email: "hello@uhomekj.com",
          contactType: "customer service"
        },
        address: {
          "@type": "PostalAddress",
          addressLocality: "上海",
          addressRegion: "上海",
          addressCountry: "CN"
        }
      },
      {
        "@type": "WebSite",
        name: "韩漫大全漫画网",
        url: "http://uhomekj.com/",
        potentialAction: {
          "@type": "SearchAction",
          target: "http://uhomekj.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": "WebPage",
        name: "韩漫大全漫画网 - 下拉式免费无删减韩漫在线阅读平台",
        description: "韩漫大全漫画网提供下拉式免费韩漫在线阅读，海量无删减韩漫资源，每日更新200+话。",
        url: "http://uhomekj.com/",
        isPartOf: { "@type": "WebSite", name: "韩漫大全漫画网", url: "http://uhomekj.com/" }
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          { "@type": "Question", name: "韩漫大全漫画网的漫画都是免费的吗？", acceptedAnswer: { "@type": "Answer", text: "是的，我们平台所有漫画均提供免费下拉式阅读体验。您无需支付任何费用即可畅享海量韩漫资源。" } },
          { "@type": "Question", name: "什么是在线下拉式阅读？", acceptedAnswer: { "@type": "Answer", text: "下拉式阅读是一种优化的网页漫画浏览方式，您只需向下滚动页面即可连续阅读漫画内容，无需翻页点击。" } },
          { "@type": "Question", name: "漫画更新频率是怎样的？", acceptedAnswer: { "@type": "Answer", text: "热门漫画通常与韩国原版保持同步更新，每周更新2-3话。一般漫画每周至少更新1话。" } },
          { "@type": "Question", name: "如何查找我喜欢的漫画？", acceptedAnswer: { "@type": "Answer", text: "您可以通过首页的搜索框直接搜索漫画名称，也可以使用分类导航按类型浏览。" } },
          { "@type": "Question", name: "平台支持哪些设备阅读？", acceptedAnswer: { "@type": "Answer", text: "韩漫大全漫画网采用响应式设计，完美适配PC端、平板和手机等各种设备。" } },
          { "@type": "Question", name: "漫画内容是否有删减？", acceptedAnswer: { "@type": "Answer", text: "我们承诺提供无删减版本的韩漫内容，忠实还原原作的完整剧情和画面。" } }
        ]
      }
    ]
  };

  usePageMeta({
    title: "韩漫大全漫画网_下拉式免费无删减韩漫在线阅读平台",
    description: "韩漫大全漫画网提供下拉式免费韩漫在线阅读，海量无删减韩漫资源，每日更新200+话，涵盖恋爱、奇幻、热血、悬疑等全类型韩国漫画。支持PC和手机端流畅阅读体验。",
    keywords: "韩漫大全漫画网,下拉式免费韩漫,无删减韩漫,韩漫在线阅读,韩漫网站,韩国漫画",
    canonical: "http://uhomekj.com/",
    jsonLd,
  });

  return (
    <>
      <Navbar />
      <main>
        <article>
          <HomeHero />
          <FeaturedComics />
          <LatestUpdates />
          <CategoryNav />
          <StatsSection />
          <FAQSection />
          <CTASection />
        </article>
      </main>
      <Footer />
    </>
  );
}